import { staticValueMap } from "./valueMappings";
import { GetRegion, GetInsuranceCompany, GetModel, GetBrand } from "./cls";

const apiResolvers = {
  RegionId: async (id) => {
    try {
      const response = await GetRegion(id);
      if (!response.data.data || !Array.isArray(response.data.data)) {
        console.warn("Invalid response format for region ID:", id);
        return id;
      }
      const region = response.data.data.find(item => item.id == id);
      return region?.name || id;
    } catch (error) {
      console.error("Error fetching region:", error);
      return id;
    }
  },
  
  InsuranceCompanyId: async (id) => {
    try {
      const response = await GetInsuranceCompany(id);
      if (!response.data.data || !Array.isArray(response.data.data)) {
        console.warn("Invalid response format for insurance company ID:", id);
        return id;
      }
      const company = response.data.data.find(item => item.id == id);
      return company?.name || id;
    } catch (error) {
      console.error("Error fetching insurance company:", error);
      return id;
    }
  },
  
  BrandId: async (id) => {
    try {
      const response = await GetBrand(id);
      if (!response.data.data || !Array.isArray(response.data.data)) {
        console.warn("Invalid response format for brand ID:", id);
        return id;
      }
      const brand = response.data.data.find(item => item.id == id);
      return brand?.name || id;
    } catch (error) {
      console.error("Error fetching brand:", error);
      return id;
    }
  },
  
  ModelId: async (id) => {
    try {
      const response = await GetModel(id);
      if (!response.data.data || !Array.isArray(response.data.data)) {
        console.warn("Invalid response format for model ID:", id);
        return id;
      }
      const model = response.data.data.find(item => item.id == id);
      return model?.name || id;
    } catch (error) {
      console.error("Error fetching model:", error);
      return id;
    }
  },
  
  regionid: async (id) => apiResolvers.RegionId(id),
  insurancecompanyid: async (id) => apiResolvers.InsuranceCompanyId(id),
  brandid: async (id) => apiResolvers.BrandId(id),
  modelid: async (id) => apiResolvers.ModelId(id),
};

export async function resolveFieldValue(key, value) {
  if (staticValueMap[key] && value in staticValueMap[key]) {
    return staticValueMap[key][value];
  }

  const resolver = apiResolvers[key];
  if (resolver) {
    try {
      const resolvedValue = await resolver(value);
      console.log(`Resolved ${key}: ${value} => ${resolvedValue}`); 
      return resolvedValue;
    } catch (error) {
      console.error(`Error resolving ${key}:`, error);
      return value;
    }
  }

  return value;
}